import { Component, Input } from '@angular/core';
import { PestRiskViewModel } from '@/app/proxy/proxies';
import { SharedModule } from '@/app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'widget-pest-details',
  imports: [SharedModule, TranslateModule],
  templateUrl: './widget-pest-details.component.html',
  styleUrl: './widget-pest-details.component.less',
})
export class WidgetPestDetailsComponent {
  @Input() pestRisk: PestRiskViewModel;
}
